import script from "./LandingDesignWebsite.vue?vue&type=script&setup=true&lang=js"
export * from "./LandingDesignWebsite.vue?vue&type=script&setup=true&lang=js"

import "./LandingDesignWebsite.vue?vue&type=style&index=0&id=6f388e9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f388e9c"]])

export default __exports__